import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';
@Component({
    selector: 'quotation-name',
    templateUrl: 'quotation.component.html'
})

export class QuotationComponent implements OnInit {
    tempPraposaBids:any;
    collaboList=[];
    userType:string;
    userID: any;
    BidsList: any=[];
    tempcollaboList: any;
    tempcol=[];
    tempColaboActorDetails: any;
    ColaboActorDetails: any;
    Actorid: string;
    ActorpercentageId: string;
    statusCollabos: any[];
    showproposal:boolean=false;
    showbids:boolean;
    tabtype: string;
    RowCollaboDetils: any;
    showPraposalDetails: any;
    searchText:any;
    c: any;
    expandedIndex = 0;
  presentCollabos: any[];
  Accordian: any;
  tabStatus: any;
  presentbid: any;
  displaydoc:boolean=false;
  proposalfilepath: any;
  
  private isCollapsed: boolean = true;
    constructor(private loginService:LoginService) {
      this.userType=localStorage.getItem("userType");
     }

    ngOnInit() {
        this.userID=localStorage.getItem('USERID');
      
        this.tabtype="bids";
        this.GetPraposalBids();
       this.showbids=true;
      
     }
     opencollabo(item){
      this.c=item;
    }
    calculateDiff(sentDate,enddate) {
      var date1:any = new Date(sentDate);
      var date2:any = new Date(enddate);
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
  
      return diffDays;
  }

    GetPraposalBids(){
        this.loginService.GetPraposalBids().subscribe(data=>
          {
              data = JSON.parse(data['_body']);
              this.tempPraposaBids=JSON.parse(JSON.stringify(data));
            
            this.BidsList=this.tempPraposaBids.filter(x=>x.userid.toString()===this.userID.toString());
            this.loginService.GetCollabos(this.userType).subscribe(data=>
                {
                    data = JSON.parse(data['_body']);
                    this.tempcollaboList=JSON.parse(JSON.stringify(data));
                 
                   this.loginService.GetCollaboActorDetails().subscribe(data1=>{

                    data1=JSON.parse(data1["_body"]);
                    this.tempColaboActorDetails=JSON.parse(JSON.stringify(data1));
                  // this.GetPraposalBids();
                 
            for(var i=0;i<this.BidsList.length;i++){
                var collabos=this.tempcollaboList.filter(x=>x.id===this.BidsList[i].collaboid)
                if(collabos.length>0){
                  
                this.collaboList.push(collabos);
                }
                var filterArray = this.collaboList.reduce((accumalator, current) => {
                  if(!accumalator.some(item => item[0].id === current[0].id )) {
                    accumalator.push(current);
                  }
                  return accumalator;
              },[]);
              this.collaboList=filterArray
            }
            var existingbids=[];
            for(var i=0;i<this.collaboList.length;i++){
              existingbids=this.BidsList.filter(x=>x.collaboid==this.collaboList[i][0].id)
                let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===(this.collaboList[i][0]).id);

if(CollaboActors.length>0)
{
  this.ColaboActorDetails=CollaboActors;
}
else{
  this.ColaboActorDetails=[];
}


if((this.collaboList[i][0]).ActorID==undefined || (this.collaboList[i][0]).ActorID=="" || (this.collaboList[i][0]).ActorID==[])
{this.Actorid="";}
else
{ this. Actorid= JSON.parse((this.collaboList[i][0]).ActorID)
}

if((this.collaboList[i][0]).ActorPercentageID==undefined || (this.collaboList[i][0]).ActorPercentageID=="" || (this.collaboList[i][0]).ActorPercentageID==[])
{this.ActorpercentageId="";
}
else
{this. ActorpercentageId= JSON.parse((this.collaboList[i][0]).ActorPercentageID)}


                this.tempcol.push({
                    region:this.collaboList[i][0].region,
                    title:this.collaboList[i][0].title,
                    paytype:this.collaboList[i][0].pay_type,
                    postedon:(this.collaboList[i][0]).createddate,
                    start_date:(this.collaboList[i][0]).start_date,
                    end_date:(this.collaboList[i][0]).end_date,
                    status:(this.collaboList[i][0]).statusname,
                    ActorID:this.ColaboActorDetails,
                    ActorPercentageID:this.ActorpercentageId,
                    statusid:(this.collaboList[i][0]).status,
                    bids:existingbids
                })
                this.statusChange(0);
             
                this.c=this.tempcol[0];
                this.presentCollabos=this.tempcol;
            }

                });
            });
          
           
  
          });
      }
      Searchtext(){
        this.tempcol=[];
        this.tempcol=this.presentCollabos;
       
       let tempCompany = this.tempcol.filter(
         (item) => {
           return (
             (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
           );
         }
      
       );
       this.tempcol = tempCompany;
      
      }
      statusChange(id){
        this.tabStatus=id;
        if(id==0)
        {
          this.statusCollabos=this.tempcol;
        }
      else {
        this.statusCollabos=this.tempcol.filter(x=>x.bidstatus===id.toString());
      }
      }
      viewdoc(doc)
      {
        window.open(this.loginService.imageURL+doc);
      }
      ShowPraposal(row,bid,tabtype)
      {
      this.tabtype='show';
      this.RowCollaboDetils=row;
this.presentbid=bid;
if(this.presentbid.proposalfilepath!="" ){
  this.displaydoc=true;
  this.proposalfilepath = this.presentbid.proposalfilepath.replace(/^.*[\\\/]/, '')
}
else{
  this.displaydoc=false;
}
      this.showproposal=true;
      this.showbids=false;
  
      }
      BackToCollabo(){
        this.showbids=true;
        this.showproposal=false;
        this.tabtype='sh'
    }
      GetCollabos(){
      }
      accordianValue(value)
      {
        this.Accordian=value;
      }
}
